import { template as template_eb030eb1462b4c0f8ba35be0450c3d92 } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { toTree } from 'eflex/util/tree-helpers';
import { array, fn } from '@ember/helper';
import { t } from 'ember-intl';
import { not, or } from 'ember-truth-helpers';
import TrashCan from 'eflex/components/trash-can';
import TreeSelect from 'eflex/components/tree-select';
import AddButton from 'eflex/components/add-button';
export default class TaskContextConfigPushToSchedule extends Component {
    @service
    store;
    @service
    areaRepo;
    get nonDeletedPushToScheduleConfigs() {
        return this.args.taskConfig.pushToScheduleConfigs.filter((item)=>!item.isDeleted);
    }
    get treeData() {
        return this.areaRepo.areas.map((area)=>toTree(area, {
                lastModel: 'station',
                filter (treeItem) {
                    if (treeItem.type === 'station') {
                        return treeItem.productionScheduleEnabled;
                    }
                    return true;
                }
            }));
    }
    addScheduleConfig = ()=>{
        this.store.createRecord('push-to-schedule-config', {
            taskConfig: this.args.taskConfig
        });
    };
    deleteScheduleConfig = (scheduleConfig)=>{
        scheduleConfig.deleteRecord();
    };
    selectStation = (scheduleConfig, [station])=>{
        if (!station) {
            scheduleConfig.station = null;
            scheduleConfig.model = null;
            return;
        }
        scheduleConfig.station = this.store.peekRecord('station', station.id);
        if (scheduleConfig.model?.area != scheduleConfig.station.area) {
            scheduleConfig.model = scheduleConfig.station.models[0];
        }
    };
    static{
        template_eb030eb1462b4c0f8ba35be0450c3d92(`
    <div class="mt-4">
      <div class="bootstrap-table">
        <div class="row form-row header-row">
          <div class="col model-specific">
            {{t "station"}}
          </div>
          <div class="col model-specific px-0">
            {{t "model"}}
          </div>
          <div class="col model-specific pe-0">
            {{t "target"}}
          </div>
          <div class="col-icon border-0" />
        </div>

        {{#each this.nonDeletedPushToScheduleConfigs as |scheduleConfig|}}
          <div class="row form-row schedule-config">
            <div class="col">
              <@form.element
                @model={{scheduleConfig}}
                @property="station"
              >
                <TreeSelect
                  class="station-select model-specific"
                  @checkable={{false}}
                  @checkedIds={{if scheduleConfig.station (array scheduleConfig.station.id) (array)}}
                  @sourceTree={{this.treeData}}
                  @minDepth={{2}}
                  @onCheckedChanged={{fn this.selectStation scheduleConfig}}
                  @disabled={{@disabled}}
                />
              </@form.element>
            </div>
            <div class="col px-0">
              <@form.element
                class="model-select model-specific"
                @controlType="power-select"
                @options={{scheduleConfig.station.models}}
                @optionLabelPath="displayName"
                @onChange={{fn (mut scheduleConfig.model)}}
                @model={{scheduleConfig}}
                @property="model"
              as |el|>
                <el.control
                  @triggerClass="form-control"
                  @disabled={{or (not scheduleConfig.station) @disabled}}
                />
              </@form.element>
            </div>
            <div class="col pe-0">
              <@form.element
                @controlType="number"
                @model={{scheduleConfig}}
                @property="scheduleTarget"
                class="model-specific"
              />
            </div>
            <div class="col-icon">
              <TrashCan
                disabled={{@disabled}}
                @onDelete={{fn this.deleteScheduleConfig scheduleConfig}}
              />
            </div>
          </div>
        {{/each}}

        <div class="row mt-3">
          <div class="col-auto">
            <AddButton
              class='add-schedule-config'
              @onClick={{this.addScheduleConfig}}
              @disabled={{@disabled}}
            >
              {{t "task.pushToSchedule.add"}}
            </AddButton>
          </div>
        </div>

      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
